import {StyleElement, StyleInstance, UI} from "./UI.js";
import {BlogEntryStore} from "../../establishment/blog/js/state/BlogStore.js";
import {Device} from "../../stemjs/src/base/Device";
import {BlogArticleRenderer} from "../../establishment/blog/js/BlogArticleRenderer.jsx";
import {HourlyContestsPanel} from "./components/HourlyContestsPanel.jsx";
import {LeaderboardPanel} from "./components/LeaderboardPanel.jsx";
import {SendFeedbackPanel} from "./components/SendFeedbackPanel.jsx";
import {InlineBlogPreview} from "./components/InlineBlogPreview.jsx";
import {UpcomingContestsPanel} from "./components/UpcomingContestsPanel.jsx";
import {isSepi} from "./state/CSAState.js";


export class FrontPagePanel extends UI.Element {
    extraNodeAttributes(attr) {
        attr.setStyle({
            margin: "0 auto",
            width: "90%",
            maxWidth: "1000px",
        });
    }

    renderInlineBlog() {
        const blogEntries = BlogEntryStore.all().sort((a, b) => {
            return b.getArticle().dateCreated - a.getArticle().dateCreated;
        });

        if (isSepi()) {
            return blogEntries.map(blogEntry => <BlogArticleRenderer article={blogEntry.getArticle()} />);
        }

        return [
            <div ref="leftPanelChild"
                 style={{
                     height: "50px",
                     lineHeight: "50px",
                     fontSize: "1.8em",
                     marginBottom: "-30px",
                     paddingLeft: "16px",
                 }}>
                {UI.T("Latest Blog Entries")}
            </div>,
            <InlineBlogPreview ref="miniBlog"/>
        ];
    }

    render() {
        const panelStyle = (width) => ({
            width: width + "%",
            display: "inline-block",
            verticalAlign:"top",
            textAlign: "none",
            whiteSpace: "initial",
            padding: "0px 10px",
            marginBottom: "-70px",
        });

        const styleElements = (
            <StyleElement>
                <StyleInstance selector="#frontPage h1" attributes={{"font-size": "1.65em", "margin-top": "9px", "margin-bottom": "5px"}}/>
                <StyleInstance selector="#frontPage h2" attributes={{"font-size": "1.15em", "margin-top": "7px", "margin-bottom": "5px"}}/>
                <StyleInstance selector="#frontPage h3" attributes={{"font-size": "0.88em", "margin-top": "7px", "margin-bottom": "5px"}}/>
                <StyleInstance selector="#frontPage h4" attributes={{"font-size": "0.71em", "margin-top": "7px", "margin-bottom": "5px"}}/>
                <StyleInstance selector="#frontPage h5" attributes={{"font-size": "0.60em", "margin-top": "7px", "margin-bottom": "5px"}}/>
                <StyleInstance selector=".panel-body" attributes={{"padding": "5px"}}/>
            </StyleElement>
        );

        if (!Device.isMobileDevice()) {
            return [
                <div ref="leftPanel" style={panelStyle(76)}>
                    {this.renderInlineBlog()}
                </div>,
                <div ref="rightPanel" style={Object.assign({}, panelStyle(23), {marginTop: "63.5px",})}>
                    <div style={{marginBottom: "40px"}}>
                        <UpcomingContestsPanel style={{"margin-bottom": "40px", marginTop: "30px"}}/>
                        {!isSepi() && <HourlyContestsPanel />}
                    </div>
                    {!isSepi() && [
                        <LeaderboardPanel ref="leaderboard" style={{marginBottom: "40px"}} bodyStyle={{padding: 0,}}/>,
                        <SendFeedbackPanel ref="suggestionPanel" style={{marginBottom: "40px"}}/>
                    ]}
                </div>,
                styleElements,
            ];
        } else {
            return [
                <div ref="leftPanel" style={panelStyle(76)}>
                    <div style={{marginBottom: "40px"}}>
                        <UpcomingContestsPanel style={{"margin-bottom": "40px", marginTop: "30px"}}/>
                    </div>
                </div>,
                <div ref="rightPanel" style={Object.assign({}, panelStyle(23), {marginTop: "63.5px",})}>
                    {this.renderInlineBlog()}
                </div>,
                !isSepi() && <div style={Object.assign({}, panelStyle(100), {marginTop: "63.5px"})}>
                    <LeaderboardPanel ref="leaderboard" bodyStyle={{padding: 0,}}/>
                    <HourlyContestsPanel style={{marginTop: "40px"}}/>
                    <SendFeedbackPanel ref="suggestionPanel" style={{marginTop: "40px", marginBottom: "40px"}}/>
                </div>,
                styleElements,
            ];
        }
    }

    recalculateDimensions() {
        let parentSize = this.getWidth();
        if (parentSize <= 900) {
            this.setStyle("white-space", "initial");
            this.rightPanel.setWidth("100%");
            this.leftPanel.setWidth("100%");
            return;
        }
        this.leftPanel.setWidth("76%");
        this.rightPanel.setWidth("23%");
        this.setStyle("white-space", "nowrap");
    }

    onMount() {
        setTimeout(() => {
            this.recalculateDimensions();
        }, 0);
        window.addEventListener("resize", () => {
            this.recalculateDimensions();
        });
        this.addListener("show", () => {
            this.recalculateDimensions();
        });
    }
}

